import {StoreProvider} from 'lowkey-component';

import {IPeopleState} from '@services/types';
import {
  intentionalitySaved,
  joinTypeSaved,
  occupationSaved,
} from '@store/peopleSlice';

export const createPeopleState = (): IPeopleState => {
  const store = StoreProvider.create();
  return {
    updateOccupation: (val: string) => {
      store.dispatch(occupationSaved(val));
    },
    updateIntentionality: (val: string) => {
      store.dispatch(intentionalitySaved(val));
    },
    updateJoinType: (val: string) => {
      store.dispatch(joinTypeSaved(val));
    },
  };
};
